import { render, staticRenderFns } from "./AppointmentBranchAddRoom.vue?vue&type=template&id=c598c774"
import script from "./AppointmentBranchAddRoom.vue?vue&type=script&lang=ts"
export * from "./AppointmentBranchAddRoom.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentBranchAddRoom.vue?vue&type=style&index=0&id=c598c774&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports